<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="6">
                <CRow>
                  <CCol sm="6">
                    <CInput
                      label="Kode Freezer"
                      invalid-feedback="Kode Freezer should be filled"
                      required
                      v-model="$v.freezerForm.freezer_code.$model"
                      :is-valid="!$v.freezerForm.freezer_code.$invalid"
                      readonly
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="6">
                    <CInput
                      label="Nama Freezer"
                      invalid-feedback="Nama Freezer should be filled"
                      required
                      v-model="$v.freezerForm.name.$model"
                      :is-valid="!$v.freezerForm.name.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                  <CCol sm="6">
                    <div class="form-group">
                      <label for="freezer_owner">Freezer Owner</label>
                      <model-select
                        class="form-control"
                        id="freezer_owner"
                        :options="freezerOwnerList"
                        v-model="$v.freezerForm.freezer_owner_code.$model"
                        :isError="$v.freezerForm.freezer_owner_code.$invalid"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.freezerForm.freezer_owner_code.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Freezer Owner should be filled.
                      </div>
                    </div>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="6">
                    <CInput
                      label="Brand"
                      invalid-feedback="Brand should be filled"
                      required
                      v-model="$v.freezerForm.brand.$model"
                      :is-valid="!$v.freezerForm.brand.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>

                  <CCol sm="6">
                    <CTextarea
                      label="SKU"
                      invalid-feedback="SKU should be filled"
                      required
                      v-model="$v.freezerForm.sku.$model"
                      :is-valid="!$v.freezerForm.sku.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="6">
                    <CInput
                      type="number"
                      label="Kapasitas"
                      min="0"
                      invalid-feedback="Kapasitas"
                      required
                      v-model="$v.freezerForm.capacity.$model"
                      :is-valid="!$v.freezerForm.capacity.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>

                  <CCol sm="6">
                    <CInput
                      type="number"
                      label="Berat"
                      min="0"
                      invalid-feedback="Berat"
                      required
                      v-model="$v.freezerForm.weight.$model"
                      :is-valid="!$v.freezerForm.weight.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="6">
                    <CInput
                      type="number"
                      label="Voltage"
                      min="0"
                      invalid-feedback="Voltage"
                      required
                      v-model="$v.freezerForm.voltage.$model"
                      :is-valid="!$v.freezerForm.voltage.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>

                  <CCol sm="6">
                    <CInput
                      label="Dimention"
                      invalid-feedback="Dimention"
                      required
                      v-model="$v.freezerForm.dimention.$model"
                      :is-valid="!$v.freezerForm.dimention.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>

                   <CCol sm="6">
                    <CInput
                      label="Image Information"
                      invalid-feedback="Image Information should be filled"
                      required
                      v-model="$v.freezerForm.image_information.$model"
                      :is-valid="!$v.freezerForm.image_information.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                </CRow>
              </CCol>

              <CCol sm="6">
                <CRow>
                  <CCol sm="12">
                    <label for="nik">Description</label>
                    <quill-editor
                      style="height: 150px; margin-bottom: 70px"
                      :content="content"
                      :options="editorOption"
                      v-model="$v.freezerForm.description.$model"
                      :disabled="isReadonly"
                      @change="onEditorChange($event)"
                    >
                    </quill-editor>
                    <div
                      v-if="$v.freezerForm.description.$invalid"
                      class="invalid-feedback-custom"
                    >
                      Description harus di isi.
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              :disabled="$v.freezerForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form Serial Number</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Serial Number"
              invalid-feedback="Serial number should be filled"
              required
              v-model="$v.freezeForm.serial_number.$model"
              :is-valid="!$v.freezeForm.serial_number.$invalid"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.freezeForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Serial Number</template>
            <br />
            <!-- <SerialNumber :withCard="false"></SerialNumber> -->
            <CRow>
              <CCol sm="12">
                <GlobalTable
                  :title="'Serial Number'"
                  :fields="fields"
                  :items="data"
                  :editButton="true"
                  :redirectDetail="false"
                  :enableAddButton="true"
                  :isLoading="isLoading"
                  :withCard="false"
                  @addForm="addForm"
                  @editForm="editForm"
                ></GlobalTable>
              </CCol>
            </CRow>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../templates/Loading";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import SerialNumber from "./tabs/SerialNumber";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "FreezersDetails",
  components: { GlobalTable, Loading, quillEditor, SerialNumber },
  data() {
    return {
      title: "Freezer Detail",
      items: [],
      freezerForm: tableInterfaces.freezers,
      freezerOwnerList: [],
      statusList: [],
      freezerUnitList: [],
      isLoading: false,
      statusFreezer: null,
      activeTab: 0,
      content: "",
      editorOption: {}, // data quill
      fields: [
        { key: "serial_number", label: "Serial Number", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      theid: "",
      freezer_code: null,
      addButton: false,
      isEdit: false,
      freezeForm: tableInterfaces.freezer_serialnmb,
    };
  },
  validations: {
    freezerForm: {
      freezer_code: { required },
      freezer_owner_code: { required },
      name: { required },
      sku: { required },
      brand: { required },
      capacity: { required },
      weight: { required },
      voltage: { required },
      dimention: { required },
      description: {},
      image_information:{},
    },
    freezeForm: {
      serial_number: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    isReadonly: function () {
      return this.statusFreezer === "1" ? true : false;
    },
    parentCategory: function () {
      return this.tempParentCategoryList.filter(
        (x) => x.group === this.freezerForm.group
      );
    },
    category: function () {
      return this.tempCategoryList.filter(
        (x) => x.parent === this.freezerForm.parent_category
      );
    },
    data: function () {
      return this.items.length > 0 ? this.items : this.freeze;
    },
  },
  methods: {
    init: function (id) {
      this.getDetailFreezer(id);
      this.getSerialNumber(id);
      this.getDropdown();
      this.theid = id;
    },
    getSerialNumber: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/freezer_serialnumber/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            // console.log(response.data)
            this.items = response.data.data;

            this.freezer_code = response.data.detail.freezer_code;

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    getDetailFreezer: function (id) {
      this.isLoading = true;
      this.resetForm();
      this.axios
        .get("console/freezer/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.freezerForm = response.data.data;

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDropdown: function () {
      this.axios.get("/console/dropdown/freezer_owner").then((response) => {
        this.freezerOwnerList = response.data.data;
      });
    },
    back: function () {
      this.$router.go(-1);
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.freezeForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.freezer_serialnmb) {
        tableInterfaces.freezer_serialnmb[i] = null;
      }

      this.freezeForm = tableInterfaces.freezer_serialnmb;

      this.freezeForm.freezer_code = this.freezer_code;
      // this.freezeForm = tableInterfaces.freezer_serialnmb;
      // this.freezerForm = tableInterfaces.freezers;
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/freezer/update", this.freezerForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Detail Freezer",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Detail Freezer");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.freezerForm.description = html;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          // console.log(this.freezeForm)
          this.axios
            .put("console/freezer_serialnumber/update", this.freezeForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.getSerialNumber(this.theid);
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          // console.log(this.freezeForm)
          this.axios
            .post("console/freezer_serialnumber/add", this.freezeForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              // console.log(this.theid)
              this.getSerialNumber(this.theid);
            });
        }
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
